<template>
    <div>
        <div v-if="attFileData.length===0" class="alert alert-warning" :class="{'mb-0': !canEdit}">没有开班通知文件</div>
        <div v-if="attFileData.length!==0">
            <table class="table table-bordered" :class="{'mb-0': !canEdit}">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">序号</th>
                    <th class="text-center align-middle" style="width: 40%">文件名</th>
                    <th class="text-center align-middle" style="width: 20%">文件类型</th>
                    <th class="text-center align-middle" style="width: 20%">备注</th>
                    <th class="text-center align-middle" style="width: 10%" v-if="canEdit">编辑</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(file, index) in attFileData" :key="file.attFileId">
                    <td class="text-center align-middle">{{ index + 1 }}</td>
                    <td class="text-left align-middle">
                        {{ file.sourceFileName }}
                        <template v-if="file.fileType===attFileType.PDF_FILE">
                            <!-- PDF文件 -->
                            <router-link :to="{name: 'pdfView', params: {attFileId: file.attFileId}}" target="_blank" class="ml-2">浏览</router-link>
                            <a :href="URL_DOWNLOAD + file.attFileId" target="_blank" class="ml-2">下载</a>
                        </template>
                        <template v-else>
                            <!-- 可下载文件 -->
                            <a :href="URL_DOWNLOAD + file.attFileId" target="_blank" class="ml-2">下载</a>
                        </template>
                    </td>
                    <td class="text-center align-middle">{{ file.attFileCategoryName }}</td>
                    <td class="text-left align-middle">{{ file.memo }}</td>
                    <td class="text-center align-middle" v-if="canEdit">
                        <button class="btn btn-danger" @click="btnDeleteAttFile(file.attFileId)">删除</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="canEdit">
            <button class="btn btn-primary" @click="btnAddAttFile_Click">上传附件文件</button>
            <input type="file" name="uploadFile" style="display: none"
                   ref="uploadFile" @change="uploadFileChange">
        </div>

        <b-modal v-model="isAddAttFileDialogOpen"
                 title="添加批次文件"
                 ok-title="确定" cancel-title="取消" @ok="addAttFileInfoDialog_OK"
                 :no-close-on-backdrop="true">
            <div class="form-group row">
                <label for="inputAttSourceFileName" class="col-sm-3 col-form-label text-right">文件名</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="inputAttSourceFileName"
                           v-model="addAttFileInfo.sourceFileName" disabled>
                </div>
            </div>
            <div class="form-group row">
                <label for="inputAttAddress" class="col-sm-3 col-form-label text-right">附件地址</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="inputAttAddress" v-model="addAttFileInfo.address"
                           disabled>
                </div>
            </div>
            <div class="form-group row mb-0">
                <label for="inputAttMemo" class="col-sm-3 col-form-label text-right">备注</label>
                <div class="col-sm-8">
                        <textarea type="text" class="form-control" id="inputAttMemo" placeholder="备注"
                                  v-model="addAttFileInfo.memo" rows="3"></textarea>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import url from "@/utils/api/url";
import dictionary from "@/utils/dictionary";
import commonApi from "@/utils/api/common";

export default {
    name: "StartClassNotificationEdit",
    props: {
        classId: {type: String, required: true},
        canEdit: {type: Boolean, required: false, default: false}
    },
    data: function () {
        return {
            URL_DOWNLOAD: url.URL_DOWNLOAD,

            attFileType: dictionary.attFileType,

            attFileData: [],
            addAttFileInfo: {
                attFileCategory: dictionary.attFileCategory.START_CLASS_NOTIFICATION_FILE,
                ownerId: this.classId,
                userId: this.$store.state.userInfo.userId,
                userName: this.$store.state.userInfo.userName,
                userType: this.$store.state.userType,
                fileName: '',
                sourceFileName: '',
                path: '',
                address: '',
                physicalPath: '',
                physicalAddress: '',
                fileType: 1,
                memo: ''
            },
            isAddAttFileDialogOpen: false,
        };
    },
    mounted() {
        this.getStartClassNotificationAttFileData();
    },
    methods: {
        getStartClassNotificationAttFileData() {
            commonApi.attFile.getAttFileData(this.classId, dictionary.attFileCategory.START_CLASS_NOTIFICATION_FILE).then(res => {
                this.attFileData = res.data;
            });
        },
        btnAddAttFile_Click() {
            this.addAttFileInfo = {
                attFileCategory: dictionary.attFileCategory.START_CLASS_NOTIFICATION_FILE,
                ownerId: this.classId,
                userId: this.$store.state.userInfo.userId,
                userName: this.$store.state.userInfo.userName,
                userType: this.$store.state.userType,
                fileName: '',
                sourceFileName: '',
                path: '',
                address: '',
                physicalPath: '',
                physicalAddress: '',
                fileType: dictionary.attFileType.OTHER_FILE,
                memo: ''
            };
            this.$refs.uploadFile.click();
        },
        uploadFileChange($event) {
            let file = $event.target.files[0];
            commonApi.file.uploadFile(file, 'StartClassNotificationFile').then(res => {
                // console.log(res.data);
                let info = res.data;

                this.addAttFileInfo.fileName = info.fileName;
                this.addAttFileInfo.sourceFileName = info.sourceFileName;
                this.addAttFileInfo.path = info.path;
                this.addAttFileInfo.address = info.address;
                this.addAttFileInfo.physicalPath = info.physicalPath;
                this.addAttFileInfo.physicalAddress = info.physicalAddress;
                if (info.fileName.toLowerCase().endsWith('.pdf')) {
                    this.addAttFileInfo.fileType = dictionary.attFileType.PDF_FILE
                }

                this.isAddAttFileDialogOpen = true;
            });
        },
        addAttFileInfoDialog_OK() {
            commonApi.attFile.insertAttFileInfo(this.addAttFileInfo).then(res => {
                this.getStartClassNotificationAttFileData();
            });
        },
        btnDeleteAttFile(attFileId) {
            if (confirm('是否删除此附件文件？')) {
                commonApi.attFile.deleteAttFileInfoById(attFileId).then(res => {
                    this.getStartClassNotificationAttFileData();
                });
            }
        },
    }
}
</script>

<style scoped>

</style>